var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTelegram = function SvgTelegram(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7615 0.641659L0.837246 8.79525C0.159662 9.05972 0.201192 10.0317 0.898447 10.2378L6.21493 11.8079L8.19959 18.1044C8.40724 18.7623 9.24074 18.9619 9.72306 18.4687L12.472 15.6614L17.8657 19.6213C18.5258 20.1058 19.4657 19.7459 19.634 18.9444L23.2062 1.86422C23.3811 1.02854 22.5578 0.330554 21.7615 0.641659ZM19.1369 4.43192L9.4176 13.0263C9.3207 13.1123 9.25877 13.231 9.2442 13.3593L8.87043 16.6852C8.85805 16.7945 8.7065 16.8091 8.67372 16.7042L7.13422 11.7433C7.06355 11.5167 7.15535 11.2704 7.35789 11.1451L18.8353 4.02682C19.099 3.86289 19.3693 4.22573 19.1369 4.43192Z",
    fill: "#61A8DE"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTelegram);
export default ForwardRef;